import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="specific--auszahlungsbetrag"
// Begrenzt den Auszahlungsbetrag auf das Guthaben und berechnet den auszuzahlenden Betrag abzüglich Bearbeitungsgebühr.
export default class extends Controller {
  static targets = ["auszahlungsbetrag", "betrag"]
  static values = {
    saldo: Number,
    bearbeitungsGebuehr: Number,
  }

  berechnen() {
    let auszahlungsbetrag = this.betragLesen(this.auszahlungsbetragTarget.value)
    auszahlungsbetrag = Math.min(Math.round(auszahlungsbetrag * 100) / 100, this.saldoValue)

    const betrag = auszahlungsbetrag > this.bearbeitungsGebuehrValue ? auszahlungsbetrag - this.bearbeitungsGebuehrValue : 0

    this.auszahlungsbetragTarget.value = auszahlungsbetrag.toFixed(2)
    this.betragTarget.value = (Math.round(betrag * 100) / 100).toFixed(2)
  }

  betragLesen(wert) {
    const betrag = Number(wert.replace(/['’\s]/g, "").replace(",", "."))
    return isNaN(betrag) ? 0 : betrag
  }
}
